import * as React from 'react';
import { RemoveLinkLabelModel } from './RemoveLinkLabelModel';
import { RemoveLinkLabelWidget } from './RemoveLinkLabelWidget';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import { DiagramEngine } from '@projectstorm/react-diagrams-core';

/**
 * @author Dylan Vorster
 */
export class RemoveLinkLabelFactory extends AbstractReactFactory<RemoveLinkLabelModel, DiagramEngine> {
	constructor() {
		super('customLabel');
	}

	generateReactWidget(event: any): JSX.Element {
		return <RemoveLinkLabelWidget model={event.model} />;
	}

	generateModel(event: any): RemoveLinkLabelModel {
		return new RemoveLinkLabelModel();
	}
}
